import { render, staticRenderFns } from "./ChatterBlankView.vue?vue&type=template&id=30895348&scoped=true"
import script from "./ChatterBlankView.vue?vue&type=script&lang=js"
export * from "./ChatterBlankView.vue?vue&type=script&lang=js"
import style0 from "./ChatterBlankView.vue?vue&type=style&index=0&id=30895348&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30895348",
  null
  
)

export default component.exports